
/* General utility functions
*  Can be used anywhere
*/

import { DERMA_PRODUCTS_CATEGORY } from "./stateTypes";

//Reference: https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
export const uniqueID = () => (
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    let r = Math.random() * 16 | 0, v = c == "x" ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  })
);

//Removes the element from the array if it finds it
export const removeFromArr = (arr, val) => {
  let index = arr.indexOf(val);
  if (index !== -1) {
    return [
      ...arr.slice(0, index),
      ...arr.slice(index + 1),
    ];
  }
  return arr;
};

export const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

//Returns a date string in the format: DD Month YYYY hh:mm
export const getDateAndTime = (date) => {
  let h = date.getHours();
  let m = date.getMinutes();
  if (h < 10) {
    h = "0" + h;
  }
  if (m < 10) {
    m = "0" + m;
  }
  return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear() + " " + h + ":" + m;
};

//Formats rands the way the Wix store did: R 1 250,00
export const formatPrice = (num) => {
  const [rands, cents] = Number(num).toFixed(2).split(".");
  return "R " + rands.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + `,${cents}`;
};

/* ------------------------ CART ------------------------ */

//Totals a list of cart items ({ sku, quantity }), ignoring any sku that isn't for sale
export const getCartTotal = (cartItems, productsBySku) => (
  cartItems.reduce((total, item) => {
    const product = productsBySku[item.sku];
    return product ? total + (product.price * item.quantity) : total;
  }, 0)
);

//Delivery for a cart subtotal, from the server's rules ({ fee, freeFrom })
export const getDeliveryFee = (subtotal, delivery) => (
  (!delivery || ((delivery.freeFrom > 0) && (subtotal >= delivery.freeFrom))) ? 0 : delivery.fee
);

//A product's Category field lists its categories: "Best Sellers, Nuts"
export const getCategories = (product) => (
  (product.category || "").split(",").map((x) => x.trim()).filter(Boolean)
);

export const inCategory = (product, category) => (
  getCategories(product).some((x) => x.toLowerCase() === category.toLowerCase())
);

//Derma 2.0® products are only for logged in customers, and only listed on /products-derma
export const isDerma = (product) => (
  inCategory(product, DERMA_PRODUCTS_CATEGORY)
);

export const getCartCount = (cartItems) => (
  cartItems.reduce((count, item) => count + item.quantity, 0)
);

//Will not trigger the callback until it hasn't been called at least 'wait' milliseconds
export const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
      timeoutId = null;
    }, wait);
  };
};

export const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

export const prefersReducedMotion = () => (
  window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches
);
